<template>
  <transition name="fade" v-if="news">
    <Konami :konami="news.konami" v-if="code" key="konami"></Konami>
    <article v-else key="content" itemscope itemtype="http://schema.org/NewsArticle">
      <header v-if="news.main">
        <div class="container">
          <div class="row">
            <div class="col-12 col-lg-10 offset-lg-1 text-center">
              <Observer name="fade-up">
                <h1 class="a11y-sr-only" v-if="news.main.title">{{ news.main.title }}</h1>
                <h3 class="h5" aria-hidden="true" data-splitting v-if="news.main.headline" itemprop="headline" v-html="news.main.headline"/>
                <h1 class="h3" aria-hidden="true" data-splitting v-if="news.main.title" itemprop="headline" v-html="news.main.title"/>
                <div class="date" v-if="news.main.date" itemprop="datePublished">
                  {{ formatDate(news.main.date) }}
                </div>
              </Observer>
            </div>
          </div>
        </div>
        <Observer name="fade-up">
          <lazy-picture class-name="visual" :item="news.main" v-if="news.main.image" preserve-ratio="true" itemprop="image"></lazy-picture>
        </Observer>
        <div class="container">
          <div class="row">
            <div class="col-12 col-lg-10 offset-lg-1 text-center">
              <Observer name="fade-up">
                <div class="wysiwyg" v-html="news.main.excerpt"></div>
              </Observer>
            </div>
          </div>
        </div>
      </header>
      <div class="content">
        <CmpRenderer :components="news.content"></CmpRenderer>
        <section class="related_product" v-if="Object.keys(relatedProduct).length || relatedProduct.length">
          <div class="container">
            <div class="product">
              <lazy-image class-name="related-product-picture" ref="pictureRelatedProduct" :item="relatedProduct.item.image" :sizes="relatedProductSizes" root-margin="0px"></lazy-image>
              <div class="detail">
                <div class="sku" v-if="relatedProduct.item.sku" v-text="relatedProduct.item.sku"></div>
                <h3 class="h6 -upper" v-if="relatedProduct.item.name" v-text="relatedProduct.item.name"></h3>
                <p v-if="relatedProduct.item.text" v-html="relatedProduct.item.text"></p>
                <router-link :to="localizedUrl + '/product/' + relatedProduct.item.routeParam" class="btn -stroke -large" v-if="relatedProduct.item.routeParam">{{ $t('Discover') }}</router-link>
              </div>
            </div>
          </div>
        </section>
        <!-- <div class="container" v-if="news.main">
          <div class="row">
            <div class="col-12 col-lg-10 offset-lg-1">
              <div class="news-nav">
                <router-link :to="localizedUrl + '/news/' + news.main.previous.uid" v-if="news.main.previous" class="news-prev">
                  <i class="icon-back"></i>
                  <span class="link-info">{{ $t('Previous Article') }}</span>
                  <span class="-upper" v-if="news.main.previous.title">{{ news.main.previous.title }}</span>
                </router-link>
                <router-link :to="localizedUrl + '/news/' + news.main.next.uid" v-if="news.main.next" class="news-next">
                  <span class="link-info">{{ $t('Next Article') }}</span>
                  <i class="icon-next"></i>
                  <span class="-upper" v-if="news.main.next.title">{{ news.main.next.title }}</span>
                </router-link>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </article>
  </transition>
</template>

<script>
import { NewsPageComponent } from 'src/modules/prismic/components/NewsPageComponent'
import { currentStoreView } from '@vue-storefront/core/lib/multistore'
import ImageManager from 'vue-storefront-prismic-ssr/utilities/ImageManager'
import LazyImage from '../components/utils/LazyImage'
import LazyPicture from '../components/utils/LazyPicture'
import Konami from '../components/utils/Konami'
import config from 'config'
import moment from 'moment'
import '../../../../node_modules/moment/min/moment-with-locales'

export default {
  name: 'News',
  mixins: [NewsPageComponent],
  components: {
    LazyImage,
    LazyPicture,
    Konami,
  },
  asyncData({ context }) {
    return new Promise((resolve, reject) => {
      if (context) {
        context.output.cacheTags.add(`news`)
      }
      return resolve()
    })
  },
  mounted() {
    this.$nextTick(() => {
      if (process.browser) {
        const Splitting = require('splitting')
        Splitting()
      }
    })
  },
  computed: {
    localizedUrl() {
      return currentStoreView().url || ''
    },
    clientUrl() {
      return config.client.url
    },
    relatedProductSizes() {
      return '(min-width: 576px) 220px, 40vw'
    },
    mainImageSizes() {
      return '(min-width: 1200px) 1200px, 100vw'
    },
    mainImage() {
      let picture = ImageManager.convert(this.news.main.image.url)
      return {
        url: picture,
        lowDefinitionUrl: ImageManager.getLowDefinition(picture, 200, this.news.main.image.height / this.news.main.image.width),
        srcset: ImageManager.getSrcSet(picture, 2400, 400, 100, this.news.main.image.height / this.news.main.image.width),
        alt: this.news.main.image.alt ? this.news.main.image.alt : this.news.main.title,
        width: this.news.main.image.width,
        height: this.news.main.image.height,
      }
    },
    relatedProduct() {
      // return this.news.content.find(o => o.component === 'news_related_product')
      let item = {}
      if (this.news.main && this.news.main.related_product && this.news.main.related_product.data && this.news.main.related_product.data.product && this.news.main.related_product.data.product[currentStoreView().storeCode]) {
        const product = this.news.main.related_product.data.product[currentStoreView().storeCode]
        if (product) {
          let picture = ImageManager.convert(`${config.magento2.imgUrl}${product.image}`, 'image', 'product')
          item = {
            item: {
              routeParam: this.news.main.related_product.uid,
              sku: product.sku,
              name: product.name,
              text: product.description ? product.description.replace(/\|\|/g, '<br />') : '',
              image: {
                url: picture,
                lowDefinitionUrl: ImageManager.getLowDefinition(picture, 150, 1.4285714286, true, 4),
                srcset: ImageManager.getSrcSet(picture, 600, 100, 50, 1.4285714286, true),
                alt: product.name,
                width: product.image.width,
                height: product.image.height,
              },
            },
          }
        }
      }
      return item
    },
  },
  methods: {
    formatDate (date) {
      const { virtualLocale, i18n } = currentStoreView()
      const { defaultLocale } = i18n
      const locale = virtualLocale ? virtualLocale : defaultLocale
      moment.locale(locale)
      return date ? moment(+new Date(date)).format('L') : null
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/core';

// Fade
.fade-enter,
.fade-leave-to {
  left: 0;
  right: 0;
}

header {
  margin: 0 auto;
  color: var(--zenith-component-text);

  .obs-fade-up {
    .h3 {
      /deep/ .char {
        opacity: 0;
        transform: translateY(-8rem);
      }
    }
  }

  .h3 {
    margin-bottom: 3rem;
    font-size: em(44);
    font-weight: 500;
    line-height: normal ;
    letter-spacing: em(0.2, 18);
    color: var(--zenith-theme-primary);

    /deep/ .word {
      overflow: hidden;
      display: inline-block;
      vertical-align: top;
    }

    /deep/ .char {
      display: inline-block;
      transform: translateY(0);
      vertical-align: top;
      padding-bottom: 1rem;

      @include appearTitle();
    }

    @include bp(max md) {
      font-size: em(25);
      letter-spacing: em(1, 25);
    }
  }

  .date {
    font-weight: 400;
    font-size: em(14);
    line-height: em(21, 14);
    letter-spacing: em(2, 14);
    color: var(--zenith-theme-primary);
    opacity: 0.4;
    margin-bottom: 8rem;
    vertical-align: text-bottom;

    @include bp(max md) {
      margin-bottom: 4rem;
    }

    i {
      vertical-align: text-bottom;
      display: inline-block;
      margin-right: 0.4rem;
    }
  }

  .wysiwyg {
    font-size: em(26);
    font-weight: 500;
    line-height: 1.6;
    letter-spacing: em(0.2, 18);

    @include bp(max md) {
      font-size: em(16);
      letter-spacing: em(1, 16);
    }
  }

  .visual {
    width: 100%;
    display: block;
    margin-bottom: 4rem;

    /deep/ img {
      width: 100%;
    }
  }
}

article {
  padding-top: 16rem;
  padding-bottom: 10rem;

  @include bp(max md) {
    padding-top: 4rem;
    padding-bottom: 5rem;
  }
}

.content {
  .wysiwyg,
  h2 {
    margin-bottom: 4rem;
    font-size: em(20);
    line-height: 1.8;
    letter-spacing: em(0.2, 18);
  }

  h2 {
    font-weight: 500;
    font-size: em(26);
    margin-bottom: 2rem;
  }

  section {
    text-align: center;
    margin: 0 auto 4rem;

    &.embed-wrapper {
      position: relative;
      padding-bottom: 56.25%; /* 16:9 */
      padding-top: 25px;
      height: 0;

      /deep/ iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    }
  }
}

aside {
  ul {
    margin: 0;
    padding: 0;
    list-style: none;
    text-align: center;
    @include bp(max md) {
      text-align: left;
    }

    li {
      margin-bottom: 2rem;

      @include bp(max md) {
        display: inline-block;
        margin-right: 4rem;
      }

      a {
        color: var(--zenith-theme-primary);
        position: relative;
        display: block;
        transition: all 0.2s ease-in-out;

        i {
          font-size: em(30);
        }

        &:focus,
        &:hover {
          transform: scale(1.1);
        }
      }
    }
  }
}

.news-nav {
  margin: 6rem 0 0 0;
  display: flex;
  justify-content: space-between;
  @include bp(max md) {
    margin-top: 2rem;
  }

  a {
    color: var(--zenith-theme-primary);
    width: 40%;

    .link-info {
      font-weight: 500;
    }

    @include bp(max md) {
      width: 50%;
    }

    i {
      display: inline-block;
      margin-right: 0.4rem;
      vertical-align: text-bottom;
      transition: all 0.2s ease-in-out;
    }

    span {
      transition: all 0.2s ease-in-out;

      &:last-child {
        color: var(--zenith-grey);
        display: block;
        margin-top: 0.8rem;

        @include bp(max md) {
          display: none;
        }
      }
    }

    &:hover,
    &:focus {
      i {
        // margin-right: 1rem;
        @include pillPrevHover();
      }
      span {
        color: var(--zenith-theme-primary);
      }
    }

    &.news-next {
      margin-left: auto;
      text-align: right;

      i {
        margin-right: 0;
        margin-left: 0.4rem;
      }
      &:hover,
      &:focus {
        i {
          margin-right: 0;
          @include pillNextHover();
        }
      }
    }
  }
}

.related_product {
  background: var(--zenith-news-related-product-background);
  padding: 6rem 0 6rem;
  @include bp(max md) {
    padding: 5rem 0 10rem;
  }

  .product {
    width: 60%;
    display: flex;
    margin: auto;
    align-items: center;
    color: var(--zenith-component-text);

    @include bp(max lg) {
      width: 80%;
    }
    @include bp(max md) {
      width: 100%;
    }

    .related-product-picture {
      width: 220px;

      /deep/ img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    .detail {
      text-align: left;
      margin-left: 2rem;
      font-size: em(12);
    }

    .sku {
      color: var(--zenith-grey);
      margin-bottom: 0.5rem;
      font-style: em(12);
      letter-spacing: em(0.2, 12);
    }

    .h6 {
      font-weight: bold;
      margin-bottom: 1rem;
      color: var(--zenith-theme-primary);
    }

    p {
      font-style: em(12);
      letter-spacing: em(0.2, 12);
      margin-bottom: 2rem;
    }

    @include bp(max md) {
      .btn.-large {
        width: 100%;
        padding-left: 4rem;
        padding-right: 4rem;
      }
    }
  }
}
</style>
